import {Component, inject, input, InputSignal} from '@angular/core';
import {UserService} from "../../core/user/services/user.service";
import {DsBoxModule, DsButtonModule, DsModalModule} from '@bmw-ds/components';

@Component({
  selector: 'app-korea-disclaimer',
  templateUrl: 'korea-disclaimer.component.html',
  imports: [DsModalModule, DsBoxModule, DsButtonModule]
})
export class KoreaDisclaimerComponent {
  private readonly userService: UserService = inject(UserService);

  readonly koreaDisclaimerState: InputSignal<{ visible: boolean }> = input<{ visible: boolean }>();

  accept(): void {
    this.koreaDisclaimerState().visible = false;
  }

  reject(): void {
    this.userService.logOut();
  }
}
